import { BadgeConfig } from '@w3lcome/types';
import { badgeScale } from '_/constants/badgeScale';

export const paper62mmx100mmTest: BadgeConfig = {
  width: 1000 * badgeScale,
  height: 620 * badgeScale,
  isTest: true,
  fields: [
    {
      type: 'text',
      subType: 'text',
      value: 'Printer is working!',
      styles: {
        top: 240 * badgeScale,
        left: 0 * badgeScale,
        width: 1000 * badgeScale,
        height: 100 * badgeScale,
        fontSize: 82 * badgeScale,
        fontWeight: 'bold',
        textAlign: 'center',
      },
    },
  ],
};
